import { createSlice } from "@reduxjs/toolkit"

export const creaArtista = createSlice({
    name: 'creaArtista',
    initialState: {
        value:
        {
            nome: '',
            cognome: '',
            durata: '',
            gruppo: '',
            genere: '',
            fb: '',
            città: '',
            regione: '',
            descrizione: '',
            numero:'',
            telefono: '',
            email: '',
            url:'',
            youtube:''
        }
    },
    reducers: {
        add: (state, action) => {//azione per aggiungere elemento tramite form 
            state.value.push(action.payload)
        },
        aggiorna: (state, action) => {//azione per aggiornare l'oggetto creato nel form 
            Object.assign(state.value, action.payload)//unisce il nuovo oggetto con quello creato nel form
        },
        sostituisci: (state, action) => {//update di un oggetto dalle form nell'oggetto 'cercaForDispatch'
            state.value = { ...state.value, ...action.payload }
        }
    }
})
export const { add, aggiorna, sostituisci } = creaArtista.actions
export const creaArtistaReducer = creaArtista.reducer